import React from 'react';
import classNames from 'classnames';

import PropertyImagePlaceholder from 'images/property-image-placeholder.png';
import styles from './styles.module.scss';

export enum DocumentCardTypes {
  ORANGE = 'orange',
  GREEN = 'green',
  PURPLE = 'purple',
  BLUE = 'blue',
  NAVYBLUE = 'navyblue',
  WHITE = 'white',
}

interface DocumentCardType {
  title: string;
  docsCount: number;
  bgColor: string;
  cardIcon?: React.ReactNode;
  onClickHandler: () => void;
}

const PlaceholderIcon = () => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.1" width="52" height="52" rx="12" fill="#51BFE1" />
    <path
      d="M31 40.584V13.084H12.25V40.584H31ZM31 40.584H40.997V21.834L30.997 19.334"
      stroke="#51BFE1"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 40.584V34.334H24.75V40.584"
      stroke="#51BFE1"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.833 18.416C16.833 18.0018 17.1528 17.666 17.5473 17.666H18.9759C19.3704 17.666 19.6902 18.0018 19.6902 18.416V19.916C19.6902 20.3302 19.3704 20.666 18.9759 20.666H17.5473C17.1528 20.666 16.833 20.3302 16.833 19.916V18.416Z"
      fill="#51BFE1"
    />
    <path
      d="M16.833 23.416C16.833 23.0018 17.1528 22.666 17.5473 22.666H18.9759C19.3704 22.666 19.6902 23.0018 19.6902 23.416V24.916C19.6902 25.3302 19.3704 25.666 18.9759 25.666H17.5473C17.1528 25.666 16.833 25.3302 16.833 24.916V23.416Z"
      fill="#51BFE1"
    />
    <path
      d="M16.833 28.416C16.833 28.0018 17.1528 27.666 17.5473 27.666H18.9759C19.3704 27.666 19.6902 28.0018 19.6902 28.416V29.916C19.6902 30.3302 19.3704 30.666 18.9759 30.666H17.5473C17.1528 30.666 16.833 30.3302 16.833 29.916V28.416Z"
      fill="#51BFE1"
    />
    <path
      d="M23.4997 18.416C23.4997 18.0018 23.8195 17.666 24.214 17.666H25.6425C26.037 17.666 26.3568 18.0018 26.3568 18.416V19.916C26.3568 20.3302 26.037 20.666 25.6425 20.666H24.214C23.8195 20.666 23.4997 20.3302 23.4997 19.916V18.416Z"
      fill="#51BFE1"
    />
    <path
      d="M23.4997 23.416C23.4997 23.0018 23.8195 22.666 24.214 22.666H25.6425C26.037 22.666 26.3568 23.0018 26.3568 23.416V24.916C26.3568 25.3302 26.037 25.666 25.6425 25.666H24.214C23.8195 25.666 23.4997 25.3302 23.4997 24.916V23.416Z"
      fill="#51BFE1"
    />
    <path
      d="M23.4997 28.416C23.4997 28.0018 23.8195 27.666 24.214 27.666H25.6425C26.037 27.666 26.3568 28.0018 26.3568 28.416V29.916C26.3568 30.3302 26.037 30.666 25.6425 30.666H24.214C23.8195 30.666 23.4997 30.3302 23.4997 29.916V28.416Z"
      fill="#51BFE1"
    />
    <path
      d="M34.333 25.084C34.333 24.6698 34.6528 24.334 35.0473 24.334H36.4759C36.8704 24.334 37.1902 24.6698 37.1902 25.084V26.584C37.1902 26.9982 36.8704 27.334 36.4759 27.334H35.0473C34.6528 27.334 34.333 26.9982 34.333 26.584V25.084Z"
      fill="#51BFE1"
    />
    <path
      d="M34.333 30.084C34.333 29.6698 34.6528 29.334 35.0473 29.334H36.4759C36.8704 29.334 37.1902 29.6698 37.1902 30.084V31.584C37.1902 31.9982 36.8704 32.334 36.4759 32.334H35.0473C34.6528 32.334 34.333 31.9982 34.333 31.584V30.084Z"
      fill="#51BFE1"
    />
    <path
      d="M34.333 35.084C34.333 34.6698 34.6528 34.334 35.0473 34.334H36.4759C36.8704 34.334 37.1902 34.6698 37.1902 35.084V36.584C37.1902 36.9982 36.8704 37.334 36.4759 37.334H35.0473C34.6528 37.334 34.333 36.9982 34.333 36.584V35.084Z"
      fill="#51BFE1"
    />
  </svg>
);

export const DocumentCard = ({
  title,
  docsCount,
  bgColor,
  cardIcon,
  onClickHandler,
}: DocumentCardType) => {
  return (
    <div className={classNames(styles.documentCard, styles[bgColor])} onClick={onClickHandler}>
      <div className={styles.content}>
        <div className={styles.imageContainer}>{cardIcon || <PlaceholderIcon />}</div>
        <p className={styles.title}>{title}</p>
        <p className={styles.count}>
          {docsCount} Document{docsCount === 1 ? '' : 's'}
        </p>
      </div>
    </div>
  );
};
